import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lib-circle-animation-button',
  templateUrl: './circle-animation-button.component.html',
  styleUrls: ['./circle-animation-button.component.scss'],
})
export class CircleAnimationButtonComponent {
  @Input() buttonLabel: string;

  @Output() clicked = new EventEmitter<void>();
}
